import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'product_list_title',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_list_button',
      dataType: ['design'],
      onlyEnglish: ['self_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
